import { render, staticRenderFns } from "./TheSubFooter.vue?vue&type=template&id=5cc6bcb2&scoped=true&"
import script from "./TheSubFooter.vue?vue&type=script&lang=js&"
export * from "./TheSubFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheSubFooter.vue?vue&type=style&index=0&id=5cc6bcb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc6bcb2",
  null
  
)

export default component.exports